import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CardComponent from "./CardComponent";
import CardOverlay from "./CardOverlay";
import { getAllCards, saveCard, deleteCard } from "../db";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { analyzeImage, generateCardJson } from "../api/openaiApi";
import "./CollectionPage.scss";
import "bootstrap/dist/css/bootstrap.min.css";

const CollectionPage = () => {
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null); // Für das Modal

  // Karten aus der DB laden
  useEffect(() => {
    const fetchCards = async () => {
      const savedCards = await getAllCards();
      setCards(savedCards);
    };
    fetchCards();
  }, []);

  useEffect(() => {
    if (selectedCard) {
      // Finde die aktualisierte Karte im `cards`-Array basierend auf der ID
      const updatedCard = cards.find((card) => card.id === selectedCard.id);
      if (updatedCard && updatedCard !== selectedCard) {
        setSelectedCard(updatedCard);
      }
    }
  }, [cards, selectedCard]);

  const updateCard = async (updatedCard) => {
    setCards((prevCards) => {
      const existingIndex = prevCards.findIndex((card) => card.id === updatedCard.id);
  
      if (existingIndex !== -1) {
        // Karte ersetzen und eine neue Referenz erzeugen
        return prevCards.map((card, index) =>
          index === existingIndex ? { ...updatedCard } : card
        );
      } else {
        // Neue Karte hinzufügen
        return [updatedCard, ...prevCards];
      }
    });
  
    if (!updatedCard.loading) {
      await saveCard(updatedCard);
    }
  };

  // Bild hochladen und Datei speichern
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const updatedCard = { ...selectedCard, file };
    updateCard(updatedCard);
  };

  const handleAnalyzeImage = async () => {    
    const { file } = selectedCard;
    let updatedCard = {...selectedCard}

    updateCard({...updatedCard, loading: true})
    setSelectedCard(null);

    try {      
      const description = await analyzeImage(file); // Datei statt Base64 übergeben
      updatedCard = { ...updatedCard, description, loading: false };
      updateCard(updatedCard);
    } catch (err) {
      updatedCard = { ...updatedCard, error: err, loading: false };
      updateCard(updatedCard);
    }
  };

  const handleGenerateCard = async () => {
    let updatedCard = {...selectedCard, description: selectedCard.tempDescription || selectedCard.description}

    updateCard({...updatedCard, values: null,  loading: true})
    setSelectedCard(null);
    
    try {
      const generatedJson = await generateCardJson(updatedCard.description);
      updateCard({ ...updatedCard, values: generatedJson, loading: false });
    } catch (err) {
      updateCard({ ...updatedCard, error: err, loading: false });
    }
  };

  // Karte löschen
  const handleDelete = () => {
    if (window.confirm("Möchtest du diese Karte wirklich löschen?")) {
      deleteCard(selectedCard.id);
      setCards((prevCards) => 
        [...prevCards.filter((f) => 
          f.id !== selectedCard.id)
        ])
      setSelectedCard(null);      
    }
  };

  const handleCloseOverlay = (e) => {
      setSelectedCard(null); // Overlay schließen
  }

  // Neue Einheit hinzufügen
  const handleAddNewUnit = () => {
    const newUnit = {
      id: Date.now(),
      name: "",
      file: null,
      description: undefined,
      values: undefined,
    };
    updateCard(newUnit);
  };

  const navigate = useNavigate();

  return (
    <Container fluid className="collection-page">
      {/* Header */}
      <div className="header">
        <Button
          className="back-button"
          variant="outline-light"
          onClick={() => navigate("/")}
        >
          ⬅
        </Button>
        <h1 onClick={() => console.log(cards)}>Karten Sammlung</h1>
      </div>

      <hr />
      <h2>Unfertige Karten</h2>
      <Row className="card-grid">
        {/* Neue Einheit hinzufügen */}
        <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-4">
          <div className="add-unit-card" onClick={handleAddNewUnit}>
            <div className="add-unit-content">+ Neue Einheit hinzufügen</div>
          </div>
        </Col>

        {/* Karten anzeigen */}
        {cards
          .filter((card) => !card.values)
          .map((card) => (
            <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-4" key={card.id}>
              <CardComponent
                card={card}
                onClick={() => {console.log(card);setSelectedCard(card)}} // Öffnet Modal
                key={card.id}
              />
            </Col>
          ))}
      </Row>

      <hr />
      <h2>Fertige Karten</h2>
      <Row className="card-grid">
        {cards
          .filter((card) => card.values)
          .map((card) => (
            <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-4" key={card.id}>
              <CardComponent
                card={card}
                onClick={() => {console.log(card); setSelectedCard(card)}} // Öffnet Modal
                key={card.id}                
              />
            </Col>
          ))}
      </Row>

      {/* Overlay */}
      {selectedCard && (
        <CardOverlay
          card={ selectedCard }
          onClose={handleCloseOverlay}
          handleDelete={handleDelete}
          handleImageUpload={handleImageUpload}
          handleAnalyzeImage={handleAnalyzeImage}
          handleGenerateCard={handleGenerateCard}    
          // handleDescriptionChange={handleDescriptionChange}      
       />
        
      )}
    </Container>
  );
};

export default CollectionPage;
